import { locationIdFormat } from "@redotech/redo-inventory-id";
import { processingSessionIdFormat } from "@redotech/redo-return-id";
import * as z from "zod";
import { ProcessingWalkPath } from "./finalize-processing-session-item";
import { ItemProcessingSession } from "./item-processing";

export const finalizeItemProcessingSession = {
  name: "finalizeItemProcessingSession" as const,
  input: z.object({
    sessionId: processingSessionIdFormat.schema,
    path: ProcessingWalkPath,
    locationId: locationIdFormat.schema,
    workstationId: z.string().optional(),
  }),
  output: z.object({ session: ItemProcessingSession }),
};
